"use strict";

exports.__esModule = true;
exports.ReportRoutes = ReportRoutes;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _ReportCollection = require("../ReportCollection");
var _UpdateReportScreen = require("../UpdateReportScreen/UpdateReportScreen");
var _ReportScreen = require("../ReportScreen/ReportScreen");
var _ReportListScreen = require("../ReportListScreen");
var _CreateReportScreen = require("../CreateReportScreen");
var _System = require("../../../System");
var _CheckAccessRoute = require("../../Core/CheckAccessRoute/CheckAccessRoute");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _AdvancedTimeline = require("../../Timeline/AdvancedTimeline");
var _PluginContext = require("../../Plugins/PluginContext");
var _AdvancedDataSources = require("../../Widgets/AdvancedDataTable/AdvancedDataSources");
var _EnhancedContextLoader = require("../../Core/EnhancedContextLoader/EnhancedContextLoader");
var _AlertsContext = require("../../Alerts/AlertsContext");
var _AuditLog = require("../../AuditLog");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// Override global settings for the layout here, see LayoutSettingsController for defaults
var settings = {
  stripeChart: {
    allowSelection: true
  },
  selection: {
    allowReportingPeriod: true
  }
};

/**
 * Routes for the report.
 */
function ReportRoutes(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.LayoutSettingsContext.Provider, settings, /*#__PURE__*/_react["default"].createElement(_ReportCollection.ReportCollectionContext.Provider, {
    controller: _ReportCollection.ReportCollection
  }, /*#__PURE__*/_react["default"].createElement(_EnhancedContextLoader.EnhancedContextLoader, {
    Context: _AdvancedDataSources.AdvancedDataSourceContext
  }, /*#__PURE__*/_react["default"].createElement(_EnhancedContextLoader.EnhancedContextLoader, {
    Context: _AdvancedTimeline.AdvancedTimelineContext
  }, /*#__PURE__*/_react["default"].createElement(_EnhancedContextLoader.EnhancedContextLoader, {
    Context: _AlertsContext.AlertsContext
  }, /*#__PURE__*/_react["default"].createElement(_EnhancedContextLoader.EnhancedContextLoader, {
    Context: _AuditLog.AuditLogContext
  }, /*#__PURE__*/_react["default"].createElement(_PluginContext.PluginSupplier, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("CreateReport"),
    element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
      permission: "CREATE_REPORTS",
      component: _CreateReportScreen.CreateReportScreen
    })
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("UpdateReport"),
    element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
      permission: "EDIT_REPORTS",
      element: /*#__PURE__*/_react["default"].createElement(_UpdateReportScreen.UpdateReportScreenWithParams, null)
    })
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("Report"),
    element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
      permission: "VIEW_REPORTS",
      element: /*#__PURE__*/_react["default"].createElement(_ReportScreen.ReportScreenWithParams, null)
    })
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("ReportList"),
    element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
      permission: "VIEW_REPORTS",
      component: _ReportListScreen.ReportListScreen
    })
  })), children)))))));
}